<template>
  <div class="patient-form-container" :class="modalTheme">
    <!-- Add the load button at the top -->
    <!-- <div class="form-actions-top">
      <button :disabled="!patientStore.currentPatient.lastName" type="button" class="btn btn-info" @click="loadFromPatientStore">Load Current Patient from Store</button>
      <button type="button" class="btn btn-secondary" @click="loadFromProps">Load from Props</button>
      <button type="button" class="btn btn-secondary" @click="loadSampleData">Load Sample Data</button>
      <span v-if="patientStore.currentPatient.lastName" class="current-patient-info"> Current: {{ patientStore.currentPatient.firstName }} {{ patientStore.currentPatient.lastName }} </span>
      <span v-else class="no-patient-info"> No current patient selected </span>
    </div> -->

    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <div class="form-section full-width" :class="userStore.borderClass">
        <h3 style="text-align: left">Pharmacy Information</h3>

        <b-form-group label="Local Pharmacy:" label-for="localPharmacy" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="localPharmacy" :class="modalTheme" v-model="form.localPharmacy" size="sm" />
        </b-form-group>

        <b-form-group label="Mail Pharmacy:" label-for="mailPharmacy" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="mailPharmacy" :class="modalTheme" v-model="form.mailPharmacy" size="sm" />
        </b-form-group>
      </div>

      <b-row>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Preferred Name</h3>

            <b-form-group label="First Name:" label-for="preferredFirstName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="preferredFirstName" :class="modalTheme" v-model="form.preferredFirstName" size="sm" />
            </b-form-group>

            <b-form-group label="Middle Name:" label-for="preferredMiddleName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="preferredMiddleName" :class="modalTheme" v-model="form.preferredMiddleName" size="sm" />
            </b-form-group>

            <b-form-group label="Last Name:" label-for="preferredLastName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="preferredLastName" :class="modalTheme" v-model="form.preferredLastName" size="sm" />
            </b-form-group>

            <b-form-group label="Nickname:" label-for="nickname" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="nickname" :class="modalTheme" v-model="form.nickname" size="sm" />
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Employment</h3>

            <b-form-group label="Employer:" label-for="employer" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="employer" :class="modalTheme" v-model="form.employer" size="sm" />
            </b-form-group>

            <b-form-group label="Status:" label-for="employerStatus" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-select
                id="employerStatus"
                :class="modalTheme"
                v-model="form.employerStatus"
                size="sm"
                :options="[
                  { value: 0, text: 'Select Status' },
                  { value: 1, text: 'Full-time' },
                  { value: 2, text: 'Part-time' },
                  { value: 3, text: 'Contractor' },
                  { value: 4, text: 'Unemployed' },
                  { value: 5, text: 'Retired' },
                  { value: 6, text: 'Student' },
                  { value: 7, text: 'Disabled' },
                ]"
              />
            </b-form-group>

            <b-form-group label="Occupation:" label-for="employerOccupation" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-select
                id="employerOccupation"
                :class="modalTheme"
                v-model="form.employerOccupation"
                size="sm"
                :options="[
                  { value: 0, text: 'Select Occupation' },
                  { value: 1, text: 'Accountant' },
                  { value: 2, text: 'Administrative Assistant' },
                  { value: 3, text: 'Architect' },
                  { value: 4, text: 'Attorney' },
                  { value: 5, text: 'Chef' },
                  { value: 6, text: 'Consultant' },
                  { value: 7, text: 'Doctor' },
                  { value: 8, text: 'Engineer' },
                  { value: 9, text: 'Manager' },
                  { value: 10, text: 'Nurse' },
                  { value: 11, text: 'Pilot' },
                  { value: 12, text: 'Police Officer' },
                  { value: 13, text: 'Programmer' },
                  { value: 14, text: 'Sales Representative' },
                  { value: 15, text: 'Teacher' },
                  { value: 16, text: 'Technician' },
                  { value: 17, text: 'Other' },
                ]"
              />
            </b-form-group>

            <b-form-group label="Industry:" label-for="employerIndustry" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-select
                id="employerIndustry"
                :class="modalTheme"
                v-model="form.employerIndustry"
                size="sm"
                :options="[
                  { value: 0, text: 'Select Industry' },
                  { value: 1, text: 'Agriculture' },
                  { value: 2, text: 'Automotive' },
                  { value: 3, text: 'Banking' },
                  { value: 4, text: 'Construction' },
                  { value: 5, text: 'Education' },
                  { value: 6, text: 'Energy' },
                  { value: 7, text: 'Entertainment' },
                  { value: 8, text: 'Finance' },
                  { value: 9, text: 'Food Service' },
                  { value: 10, text: 'Government' },
                  { value: 11, text: 'Healthcare' },
                  { value: 12, text: 'Hospitality' },
                  { value: 13, text: 'Insurance' },
                  { value: 14, text: 'Legal' },
                  { value: 15, text: 'Manufacturing' },
                  { value: 16, text: 'Non-Profit' },
                  { value: 17, text: 'Real Estate' },
                  { value: 18, text: 'Retail' },
                  { value: 19, text: 'Technology' },
                  { value: 20, text: 'Telecommunications' },
                  { value: 21, text: 'Transportation' },
                  { value: 22, text: 'Other' },
                ]"
              />
            </b-form-group>

            <b-form-group label="Start Date:" label-for="employerStartDate" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="employerStartDate" :class="modalTheme" v-model="form.employerStartDate" type="date" size="sm" />
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Former Name</h3>

            <b-form-group label="First Name:" label-for="formerFirstName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="formerFirstName" :class="modalTheme" v-model="form.formerFirstName" size="sm" />
            </b-form-group>

            <b-form-group label="Middle Name:" label-for="formerMiddleName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="formerMiddleName" :class="modalTheme" v-model="form.formerMiddleName" size="sm" />
            </b-form-group>

            <b-form-group label="Last Name:" label-for="formerLastName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="formerLastName" :class="modalTheme" v-model="form.formerLastName" size="sm" />
            </b-form-group>

            <b-form-group label="Used Until:" label-for="formerUsedUntil" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="formerUsedUntil" :class="modalTheme" v-model="form.formerUsedUntil" type="date" size="sm" />
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">On File:</h3>

            <b-form-group label="Release of Information on File:" label-for="onfileROI" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-select
                id="onfileROI"
                :class="modalTheme"
                v-model="form.onfileROI"
                size="sm"
                :options="[
                  { value: 0, text: 'Select Status' },
                  { value: 1, text: 'Yes' },
                  { value: 2, text: 'No' },
                  { value: 3, text: 'Pending' },
                  { value: 4, text: 'Expired' },
                ]"
              />
            </b-form-group>

            <b-form-group label="HCFA Signature on File:" label-for="onfileHCFASignature" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-select
                id="onfileHCFASignature"
                :class="modalTheme"
                v-model="form.onfileHCFASignature"
                size="sm"
                :options="[
                  { value: 0, text: 'Select Status' },
                  { value: 1, text: 'Yes' },
                  { value: 2, text: 'No' },
                  { value: 3, text: 'Pending' },
                  { value: 4, text: 'Expired' },
                ]"
              />
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Birth Name</h3>

            <b-form-group label="First Name:" label-for="birthFirstName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="birthFirstName" :class="modalTheme" v-model="form.birthFirstName" size="sm" />
            </b-form-group>

            <b-form-group label="Middle Name:" label-for="birthMiddleName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="birthMiddleName" :class="modalTheme" v-model="form.birthMiddleName" size="sm" />
            </b-form-group>

            <b-form-group label="Last Name:" label-for="birthLastName" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="birthLastName" :class="modalTheme" v-model="form.birthLastName" size="sm" />
            </b-form-group>

            <b-form-group label="Used Until:" label-for="birthUsedUntil" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-input id="birthUsedUntil" :class="modalTheme" v-model="form.birthUsedUntil" type="date" size="sm" />
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="form-section" :class="userStore.borderClass">
            <h3 style="text-align: left">Patient Status</h3>

            <b-form-group label="Notification Method:" label-for="notificationMethod" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-select
                id="notificationMethod"
                :class="modalTheme"
                v-model="form.notificationMethod"
                size="sm"
                :options="[
                  { value: 0, text: 'Select Method' },
                  { value: 1, text: 'Phone' },
                  { value: 2, text: 'Email' },
                  { value: 3, text: 'Mail' },
                  { value: 4, text: 'Text Message' },
                  { value: 5, text: 'Patient Portal' },
                ]"
              />
            </b-form-group>

            <b-form-group label="VIP Indicator:" label-for="VipIndicator" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
              <b-form-checkbox id="VipIndicator" :class="modalTheme" v-model="form.VipIndicator" size="sm" switch />
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <pre style="color: cyan">{{ form }}</pre>
      <hr />
      <div class="form-actions">
        <b-button type="reset" variant="secondary">Reset</b-button>
        <b-button type="submit" variant="primary">Save Patient</b-button>
      </div>
    </b-form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import moment from "moment";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// * STORE
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

// Emits
const emit = defineEmits(["save-patient", "reset-form"]);

// & PROPS
const props = defineProps({
  testPatient: {
    Type: Object,
    Default: () => {},
  },
});

// Create form factory function
function createForm() {
  return {
    localPharmacy: "",
    mailPharmacy: "",

    preferredFirstName: "",
    preferredMiddleName: "",
    preferredLastName: "",
    formerFirstName: "",
    formerMiddleName: "",
    formerLastName: "",
    formerUsedUntil: "",
    birthFirstName: "",
    birthMiddleName: "",
    birthLastName: "",
    birthUsedUntil: "",

    nickname: "",

    employer: "",
    employerStatus: 0,
    employerOccupation: 0,
    employerIndustry: 0,
    employerStartDate: "",

    onfileROI: 0, // Release of Information
    onfileHCFASignature: 0, // HCFA-1500 Signature

    notificationMethod: 0,

    VipIndicator: false,
  };
}

// Form state
const form = ref(createForm());
const AreIdsShown = ref(true);

// Form validation
const isFormValid = () => {
  if (!form.value.firstName.trim()) {
    alert("First name is required");
    return false;
  }
  if (!form.value.lastName.trim()) {
    alert("Last name is required");
    return false;
  }
  if (!form.value.patientID.trim()) {
    alert("Patient ID is required");
    return false;
  }
  return true;
};

// Form handlers
function onSubmit() {
  if (!isFormValid()) {
    return;
  }

  const payload = {
    ...form.value,
    // Convert date strings to proper formats if needed
    chartReviewDate: form.value.chartReviewDate ? new Date(form.value.chartReviewDate).toISOString() : null,
    startDate: form.value.startDate ? new Date(form.value.startDate).toISOString() : null,
    endDate: form.value.endDate ? new Date(form.value.endDate).toISOString() : null,
    nextAppointment: form.value.nextAppointment ? new Date(form.value.nextAppointment).toISOString() : null,
    serviceDate: form.value.serviceDate ? moment(form.value.serviceDate).format("MM/DD/YYYY") : "",
  };

  emit("save-patient", payload);
  console.log("Saving patient:", payload);
}

function onReset() {
  form.value = createForm();
  emit("reset-form");
}

// Load initial data (example with the provided values)
function loadSampleData() {
  form.value = {
    personID: 14526,
    firstName: "Sample",
    middleName: "M",
    lastName: "DATA",
    dateOfBirth: "1971-09-16",
    patientID: "2405061",
    memberID: "N/A",
    insuranceCarrier: "UNKNOWN",
    dob: "19710916",
    gender: "F",
    providerName: "Grizzle, Melissa",
    serviceDate: "2022-12-14",
    lastSeenByMe: "Grizzle, Melissa",
    chartReviewDate: moment("0001-01-01T00:00:00Z").isValid() ? moment("0001-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
    chartReviewBy: null,
    chartReviewNeeded: true,
    chartReviewComment: null,
    chartReviewRole: null,
    emrId: null,
    startDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    nextAppointmentWith: "",
    nextAppointmentReason: "",
    nextAppointmentType: "",
    nextAppointmentComment: "",
    patientStatus: true,
    endDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    appointmentLocation: null,
    isScheduled: false,
    nextAppointment: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
  };
}
function loadFromProps() {
  if (props.testPatient && typeof props.testPatient === "object") {
    form.value = {
      ...createForm(),
      ...props.testPatient,
      chartReviewDate: props.testPatient.chartReviewDate ? moment(props.testPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: props.testPatient.startDate ? moment(props.testPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: props.testPatient.endDate ? moment(props.testPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: props.testPatient.nextAppointment ? moment(props.testPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
  }
}

// New method to bind from store object to form
function loadFromPatientStore() {
  const currentPatient = patientStore.currentPatient;
  if (currentPatient && typeof currentPatient === "object") {
    form.value = {
      ...createForm(),
      ...currentPatient,
      // Handle date conversions
      dateOfBirth: currentPatient.dateOfBirth ? moment(currentPatient.dateOfBirth).format("YYYY-MM-DD") : "",
      serviceDate: currentPatient.serviceDate ? moment(currentPatient.serviceDate).format("YYYY-MM-DD") : "",
      chartReviewDate: currentPatient.chartReviewDate ? moment(currentPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: currentPatient.startDate ? moment(currentPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: currentPatient.endDate ? moment(currentPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: currentPatient.nextAppointment ? moment(currentPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
    console.log("Loaded patient from store:", currentPatient);
  } else {
    console.warn("No current patient found in store");
    alert("No current patient available in store");
  }
}

onMounted(() => {
  // console.log("onMounted() : Patient Form >>>>");
  // console.log("props : testPatient ");
  // console.log(props.testPatient);
  // loadSampleData();
  // loadFromProps();
  // loadFromPatientStore();
});

const modalTheme = computed(() => userStore.bModalTheme);
</script>

<style scoped>
.patient-form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  height: 65vh;
  overflow: hidden;
  overflow-y: auto;
}

.form-section {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.form-section h3 {
  margin-bottom: 15px;
  font-size: 1.2em;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  text-align: center;
}

.form-section.full-width {
  flex: 0 0 100%;
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

hr {
  border: none;
  height: 1px;
  background-color: #0d85fd;
  margin: 20px 0;
}

/* Bootstrap Vue form group label alignment */
.b-form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Remove Bootstrap Vue form group internal spacing */
.b-form-group {
  margin-bottom: 0.5rem !important;
}

.b-form-group .row {
  margin: 0 !important;
}

.b-form-group .row > [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* 10px gap between label and input columns */
.form-section .b-form-group .row > [class*="col"]:first-child {
  padding-right: 10px !important;
  padding-left: 0 !important;
}

.form-section .b-form-group .row > [class*="col"]:not(:first-child) {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group {
    min-width: unset;
  }
}
</style>
